import "rc-tooltip/assets/bootstrap.css";
import "rc-slider/assets/index.css";
import React, { useState } from "react";
import Slider from "rc-slider";
import styled from "styled-components";
import useLanguage from "../../../utilities/useLanguage";
import { getTranslation } from "../translations";

const SliderContainer = styled.div`

.rc-slider-dot {
    position: absolute;
    bottom: -9px;
    margin-left: -1px;
    width: 2px;
    height: 12px;
    border: none;
    background-color: #dedede;
    cursor: pointer;
    border-radius: 0;
    vertical-align: middle;
}

.rc-slider-dot:nth-child(4n+5) {
    background-color: #8d8d8d;
}

.rc-slider-dot:nth-child(9) {
    height: 26px;
    bottom: -16px;
    width: 3px;
}

.rc-slider-dot:first-child, .rc-slider-dot:last-child {
    background-color: transparent;
}

.rc-slider-handle, .rc-slider-handle-click-focused {
    border: 5px solid white;
    background-color: ${props => props.theme.primary};
    width: 24px;
    height: 24px;
    box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.2), 2px 2px 3px 1px rgba(0,0,0,0.19);
}

.rc-slider-mark {
    top: 22px;
    color: #999;
    padding-left: 5px;
    padding-right: 5px;

    .rc-slider-mark-text, .rc-slider-mark-text-active {
        font-size: 0.556rem;
        top: 0px;
    }
    
    .rc-slider-mark-text:first-child {
        left: 10px !important;
    }

    .rc-slider-mark-text:last-child {
        padding-right: 16px;
    }

    .rc-slider-selected {
        font-size: 0.611rem;
        display: inline-block;
        margin-top: 8px;
        white-space: nowrap;
    }
}

.rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: #e9ecef;
    height: 14px;
    border-radius: 3px;
    top: 5px;
}

.rc-slider-track {
    background-color: transparent;
}

.rc-slider-tooltip {
    .rc-slider-tooltip-inner {
        background: transparent;
        color: #999;
        box-shadow: none;
        font-size: 11px;
        padding: 0;
    }
}
.slider-header {
    font-size: 0.667rem;
}
`;

interface IInputSliderProps {
    onChange: (percentage: number) => void;
}

export default ({ onChange }: IInputSliderProps) => {
    const [selectedMark, setSelectedMark] = useState(0);
    const { lang } = useLanguage();

    function getMarks() {
        const originalMarks = {
            "-1": "-1%",
            "-0.875": "",
            "-0.75": "",
            "-0.625": "",
            "-0.5": "",
            "-0.375": "",
            "-0.25": "",
            "-0.125": "",
            "0": "",
            "0.125": "",
            "0.25": "",
            "0.375": "",
            "0.5": "",
            "0.625": "",
            "0.75": "",
            "0.875": "",
            "1": "+1%",
        };
        const markSign = selectedMark === 1 ? '+' : '';
        return {...originalMarks, [String(selectedMark)]: <span className="rc-slider-selected">{`${markSign}${selectedMark} %` }</span>}
    }

    function handleChange(percentage) {
        setSelectedMark(percentage);
        onChange(percentage);
    }

    return (
        <SliderContainer className="w-100 mb-5 text-center">
            <div className="slider-header mb-3 font-weight-bold">{getTranslation(lang).todaysRate}</div>
            <Slider marks={getMarks()} min={-1} max={1} defaultValue={0} onChange={handleChange} step={.125} />
        </SliderContainer>
    );
};